import { Flex, Popover, theme } from 'antd'
import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Text } from 'src/components'

import { demoPresetsInfo } from './IndustrySelect/demoPresetsInfo'

type Props = {
  codename: string
  title: string
}

const isDemoPresetKey = (
  value: string
): value is keyof typeof demoPresetsInfo => value in demoPresetsInfo

export const IndustrySelectItem = ({ codename, title }: Props) => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  if (!isDemoPresetKey(codename)) {
    return title
  }

  const info = demoPresetsInfo[codename]
  const Icon = info.icon
  const color = token[info.colorToken]

  return (
    <Flex align="center" justify="space-between" gap={8}>
      <Flex align="center" gap={6}>
        <Icon size={18} color={String(color)} />
        <Text>{title}</Text>
      </Flex>

      <Popover
        content={
          <Flex orientation="vertical">
            <Text strong>{t(info.titleKey)}</Text>
            <Text>{t(info.descriptionKey)}</Text>
          </Flex>
        }
      >
        <Info size={16} color={token.colorTextSecondary} />
      </Popover>
    </Flex>
  )
}
